import { Backdrop, CircularProgress, Typography } from "@mui/material";
interface ISpinnerOverlay {
  show: boolean;
  title?: string;
}
export const SpinnerOverlay = (props: ISpinnerOverlay) => {
  return (
    <Backdrop
      sx={{
        display: "flex",
        flexDirection: "column",
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={props.show}
    >
      <CircularProgress color="inherit" />
      {props.title ? (
        <Typography sx={{ mt: 2 }} variant="caption">
          {props.title}
        </Typography>
      ) : null}
    </Backdrop>
  );
};
